import { createDynamicContext } from 'js/store/helpers';

import * as reducer from './reducer';

export const {
    withDynamicReducer,
    useDynamicReducerSelector,
    useDynamicReducerDispatch
} = createDynamicContext('Layer', reducer);
